import { Link } from 'react-router-dom'

export default function NotAuthorized() {
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 p-6">
      <h2 className="text-lg font-semibold">Not authorized</h2>
      <p className="mt-2 text-sm text-white/70">You do not have access to this area.</p>
      <Link
        to="/settings"
        className="mt-4 inline-flex items-center rounded-lg border border-white/15 px-3 py-1.5 text-sm font-semibold text-white hover:bg-white/10"
      >
        Back to settings
      </Link>
    </div>
  )
}
